/* eslint-disable react/no-array-index-key */
import React from 'react';
import parse from 'html-react-parser';
import { useHistory } from 'react-router-dom';
import AUIButton from '@ancert/aui-button';
import { ROUTES } from '../../../constants/routes.constants';
import { useTheme } from '../../../context/theme.context';

const CanalDenuncia = () => {
  const history = useHistory();
  const { homeText } = useTheme();

  return (
    <div className="c-sii-canal-denuncia">
      <h1>{homeText?.title}</h1>
      <div className="o-sii-desc-container">
        {homeText?.body && <>{parse(homeText?.body)}</> }
      </div>
      <AUIButton size="lg" label="Formular una denuncia" onClick={() => history.push(ROUTES.FORMULAR_DENUNCIA)} />
    </div>
  );
};

export default CanalDenuncia;
